document.addEventListener('DOMContentLoaded', function () {
  const ring = document.getElementById('wkndWheelRing');
  if (!ring) return;

  const items = document.querySelectorAll('.wknd-wheel__item');
  const panels = document.querySelectorAll('.wknd-wheel-details__panel');
  let currentRotation = 0;

  const angles = { usage: 0, ingredients: 90, details: 180, texture: 270 };

  function activate(key) {
    const targetAngle = angles[key];
    // Rotate ring so this item's angle lands at the top (0deg)
    let delta = -targetAngle;

    // Normalize to avoid the ring spinning the long way around
    while (delta - currentRotation > 180) delta -= 360;
    while (delta - currentRotation < -180) delta += 360;

    currentRotation = delta;
    ring.style.transform = `rotate(${currentRotation}deg)`;
    ring.style.setProperty('--wheel-rotation', `${currentRotation}deg`);

    items.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.key === key);
      item.querySelector('.wknd-wheel__item-inner').style.setProperty('--wheel-rotation', `${currentRotation}deg`);
    });

    panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.panel === key);
    });
  }

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => activate(item.dataset.key));
  });

  activate('usage');
});
